angular.module('zc.projects')

.directive 'zcReviewLinkEditor', (ProjectParticularEvent, Meta, BaseProjectCrudEditor) ->
  editor = new BaseProjectCrudEditor(
    ProjectParticularEvent
    Meta
    '/templates/projects.settings/other/review_link_editor.html'
  )
  editor.link = (scope, elem, attrs) ->
    scope.$watch 'items', (items) ->
      return unless items
      scope.filteredItems = _.filter items, {name: 'review_link', page_type: 'item'}
    , true
  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/other/review_link_editor.directive.coffee